export const SERVICE_URL = process.env.SERVICE_URL;
export const BLOB_URL = process.env.BLOB_URL;
export const AUTH0_REDIRECT = process.env.AUTH0_REDIRECT;
export const AUTH0_DOMAIN = process.env.AUTH0_DOMAIN;
export const AUTH0_AUDIENCE = process.env.AUTH0_AUDIENCE;
export const AUTH0_CLIENTID = process.env.AUTH0_CLIENTID;
export const AUTH0_SCOPE =
  "openid profile manage:images manage:addresses manage:orders";

export const CARD_OVERLAY = `${BLOB_URL}images/CardOverlayNoCorners.png`;

export const STORAGE_CART = "TB_CART";

export const ACTION_ADD_ALERT = "ACTION_ADD_ALERT";
export const ACTION_DISMISS_ALERT = "ACTION_DISMISS_ALERT";
export const ACTION_SET_BUSY = "ACTION_SET_BUSY";
export const ACTION_SET_CART = "ACTION_SET_CART";
export const ACTION_INITIALIZE_PROFILE = "ACTION_INITIALIZE_PROFILE";

export const ALERT_TYPE_ERROR = "Error";
export const ALERT_TYPE_SUCCESS = "Success";

export const VALIDATION_EMAIL =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const VALIDATION_ZIP = /^\d{5}$|^\d{5}-\d{4}$/;

export const MIN_CARD_VALUE = 10;
export const MAX_CARD_VALUE = 5000;
export const MIN_CARD_QUANTITY = 1;
export const MAX_CARD_QUANTITY = 10;
export const PLASTIC_TYPE_THEM = "Them";
export const PLASTIC_TYPE_ME = "Me";
export const EMAIL_TYPE_NOW = "Now";
export const EMAIL_TYPE_LATER = "Later";
export const SYNCHRONIZE_YES = "Yes";
export const SYNCHRONIZE_NO = "No";
export const CARD_TYPE_PLASTIC = "Plastic";
export const CARD_TYPE_EMAIL = "Email";
export const CARD_TYPE_PRINTER = "Printer";
export const STATES = [
  { abbreviation: "AL", name: "Alabama" },
  { abbreviation: "AK", name: "Alaska" },
  { abbreviation: "AZ", name: "Arizona" },
  { abbreviation: "AR", name: "Arkansas" },
  { abbreviation: "CA", name: "California" },
  { abbreviation: "CO", name: "Colorado" },
  { abbreviation: "CT", name: "Connecticut" },
  { abbreviation: "DE", name: "Delaware" },
  { abbreviation: "DC", name: "District of Columbia" },
  { abbreviation: "FL", name: "Florida" },
  { abbreviation: "GA", name: "Georgia" },
  { abbreviation: "HI", name: "Hawaii" },
  { abbreviation: "ID", name: "Idaho" },
  { abbreviation: "IL", name: "Illinois" },
  { abbreviation: "IN", name: "Indiana" },
  { abbreviation: "IA", name: "Iowa" },
  { abbreviation: "KS", name: "Kansas" },
  { abbreviation: "KY", name: "Kentucky" },
  { abbreviation: "LA", name: "Louisiana" },
  { abbreviation: "ME", name: "Maine" },
  { abbreviation: "MD", name: "Maryland" },
  { abbreviation: "MA", name: "Massachusetts" },
  { abbreviation: "MI", name: "Michigan" },
  { abbreviation: "MN", name: "Minnesota" },
  { abbreviation: "MS", name: "Mississippi" },
  { abbreviation: "MO", name: "Missouri" },
  { abbreviation: "MT", name: "Montana" },
  { abbreviation: "NE", name: "Nebraska" },
  { abbreviation: "NV", name: "Nevada" },
  { abbreviation: "NH", name: "New Hampshire" },
  { abbreviation: "NJ", name: "New Jersey" },
  { abbreviation: "NM", name: "New Mexico" },
  { abbreviation: "NY", name: "New York" },
  { abbreviation: "NC", name: "North Carolina" },
  { abbreviation: "ND", name: "North Dakota" },
  { abbreviation: "OH", name: "Ohio" },
  { abbreviation: "OK", name: "Oklahoma" },
  { abbreviation: "OR", name: "Oregon" },
  { abbreviation: "PA", name: "Pennsylvania" },
  { abbreviation: "RI", name: "Rhode Island" },
  { abbreviation: "SC", name: "South Carolina" },
  { abbreviation: "SD", name: "South Dakota" },
  { abbreviation: "TN", name: "Tennessee" },
  { abbreviation: "TX", name: "Texas" },
  { abbreviation: "UT", name: "Utah" },
  { abbreviation: "VT", name: "Vermont" },
  { abbreviation: "VA", name: "Virginia" },
  { abbreviation: "WA", name: "Washington" },
  { abbreviation: "WV", name: "West Virginia" },
  { abbreviation: "WI", name: "Wisconsin" },
  { abbreviation: "WY", name: "Wyoming" },
];

export const DEFAULT_CARD_VALUE = 40;
export const DEFAULT_CARD_TYPE = CARD_TYPE_EMAIL;
export const DEFAULT_CARD_QUANTITY = 1;
export const DEFAULT_MAIL_OPTION = PLASTIC_TYPE_ME;
export const DEFAULT_EMAIL_OPTION = EMAIL_TYPE_LATER;
export const DEFAULT_SHIPPING_STATE = "";
export const DEFAULT_SHIPPING_METHOD = "USPS-Priority";
export const DEFAULT_SYNCHRONIZE_VALUE = SYNCHRONIZE_YES;

export const PLASTIC_ME_COLUMNS = [
  { label: "From", key: "from" },
  { label: "To", key: "to" },
  { label: "Message", key: "message" },
];
export const PLASTIC_THEM_COLUMNS = [
  { label: "From", key: "from" },
  { label: "To", key: "to" },
  { label: "Message", key: "message" },
  { label: "Shipping Name", key: "name" },
  { label: "Shipping Company", key: "company" },
  { label: "Shipping Address", key: "address" },
  { label: "Shipping City", key: "city" },
  { label: "Shipping State", key: "state" },
  { label: "Shipping Zip", key: "zip" },
];
export const EMAIL_LATER_COLUMNS = [
  { label: "From", key: "from" },
  { label: "To", key: "to" },
  // { label: "DeliveryDate", key: "deliverydate" },
  { label: "Message", key: "message" },
  { label: "Email", key: "email" },
];
export const PRINTER_COLUMNS = [
  { label: "From", key: "from" },
  { label: "To", key: "to" },
  { label: "Message", key: "message" },
];
